// 個人情報の簡易チェック（現行ローカル版 index.html の checkPII を移植）。
// 「山田様」「山田さん」のように、敬称の直前に2〜4文字の漢字/カタカナが
// 続く箇所を拾う。あくまで注意喚起で、確実な検出ではない。最終確認は職員が行う。

const HONORIFIC = /([一-龯ァ-ヴー]{2,4})(様|さん|君|ちゃん)/g;
const IGNORE = new Set([
  '利用者', '御利用者', 'ご利用者', '職員', 'スタッフ', '担当者', '本人',
  '家族', 'ご家族', '御家族', '皆', 'みな', 'ケアマネ', '看護師',
]);

/** テキストから氏名らしき表記・電話番号・10桁の番号を検出し、配列で返す（無ければ空配列）。 */
export function checkPII(text) {
  const found = new Set();
  for (const m of text.matchAll(HONORIFIC)) {
    if (!IGNORE.has(m[1])) found.add(m[0]);
  }
  if (/\d{2,4}-\d{2,4}-\d{4}/.test(text)) found.add('電話番号らしい数字');
  if (/\b\d{10}\b/.test(text)) found.add('10桁の番号');
  return [...found];
}

/**
 * 検出した氏名らしき表記を「A様」「Bさん」のように置き換える（ボタンで明示的に
 * 押した時だけ呼ぶ想定。無言の自動置換はしない＝見落としに気づけなくなるため）。
 * 同じ名前は同じ文字に統一し、敬称（様／さん／君／ちゃん）はそのまま残す。
 * 電話番号・10桁の番号は対象外（置き換え後の形が定まらないため、警告のみ）。
 */
export function replacePII(text) {
  const nameToLetter = new Map();
  let nextIndex = 0;

  function letterFor(name) {
    if (!nameToLetter.has(name)) {
      const letter = nextIndex < 26
        ? String.fromCharCode(65 + nextIndex)
        : String.fromCharCode(65 + (nextIndex % 26)) + (Math.floor(nextIndex / 26) + 1);
      nameToLetter.set(name, letter);
      nextIndex += 1;
    }
    return nameToLetter.get(name);
  }

  return text.replace(HONORIFIC, (match, name, honorific) => (
    IGNORE.has(name) ? match : `${letterFor(name)}${honorific}`
  ));
}
